import Api from '@/services/Api';

export default {
  getComponents() {
    return Api().get('components/', {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  createComponent(data: {userId: number, name: string, description: string}, foods: Array<{foodid: string}>) {
    return Api().post<{id: number, name: string}>('components/create', { data, foods }, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  updateComponent(id: number, name: string) {
    return Api().put(`components/${id}`, { name }, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  getComponent(id: number) {
    return Api().get(`components/${id}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  updateComponentFood(componentId: string, food: {foodid: number}) {
    return Api().put(`components/${componentId}/${food.foodid}`, { food }, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  },
  deleteComponent(id: number) {
    return Api().delete(`components/${id}`, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Authorization': 'bearer ' + window.localStorage.getItem('token')
      }
    });
  }
};
